import {
  Button,
  FormControlLabel,
  Grid2 as Grid,
  Radio,
  RadioGroup,
  Slider,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import "../Assets/css/index.css";
import { InputLabel } from "../Common/Components/InputLabel";
import { NumberField } from "../Common/Components/NumberField";
import { theme } from "../Common/SetupProfile/constant";
import axiosMain from "../http/axiosMain";

function Contact() {
  const {
    values,
    handleChange,
    errors,
    setFieldError,
    setFieldValue,
    resetForm,
    handleSubmit,
  } = useFormik({
    initialValues: {
      name: "",
      email: "",
      mobile: "",
      subject: "",
      role: "brand",
      budget: [3000, 5000000],
      message: "",
    },
    validateOnChange: false,
    validationSchema: Yup.object({
      name: Yup.string()
        .matches(/^[a-zA-Z\s]+$/, "Only alphabets and spaces are allowed")
        .required("Please enter your name."),
      email: Yup.string()
        .email("Please enter a valid email address.")
        .matches(
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Please enter a valid email address."
        )
        .required("Please enter your email."),
      mobile: Yup.string()
        .matches(/^[0-9]+$/, "Only numbers are allowed")
        .matches(/^\d{10}$/, "Phone number must be 10 digits.")
        .required("Please enter your phone number."),
      role: Yup.string().required(
        "Please select whether you are a Brand or an Influencer."
      ),
      subject: Yup.string().required("Please enter subject."),
      message: Yup.string()
        .min(10, "Message should be at least 10 characters.")
        .max(500, "Message cannot exceed 500 characters.")
        .required("Please enter your message.")
        .test(
          "not-only-space",
          "Message cannot be just spaces",
          (value) => value && value.trim().length > 0
        ),
    }),
    onSubmit: async (data) => {
      try {
        // Only include budget if role is brand
        const submitData = {
          ...data,
        };

        // Remove budget from data if role is not brand
        if (data.role !== "brand") {
          delete submitData.budget;
        }

        console.log("Submitting data:", submitData);
        await axiosMain.post("api/contactus/contacts", submitData);

        resetForm();
      } catch (error) {
        console.error("Error submitting form", error);
      }
    },
  });

  console.log(values);

  return (
    <>
      <div className="contact-container">
        {/* Hero Section */}
        <div className="hero-section d-flex align-items-center justify-content-center">
          <div className="text-center">
            <h1 className="hero-title mt-auto">
              Where Connections Spark and Collaborations Begin
            </h1>
            <span className="text-light">
              <hr />
            </span>
          </div>
        </div>

        {/* Main Contact Section */}
        <div className="contact-content container p-5">
          <div className="row g-5">
            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-5">
              <h3 className="contact-Title">
                We'd Love to Hear From You!
              </h3>
              <p className="description">
                Whether you have a question, a project in mind, or just want to
                say hello, we're here for you. Reach out to us and let's start
                something amazing together!
              </p>
              <h5 className="get-in-touch">Get in Touch</h5>
              <ul className="contact-info">
                <li>
                  <span className="contact-label">Email : </span>
                  <Link
                    href="mailto:support@insocialorbit.com"
                    className="contact-email"
                    style={{
                      color: "rgba(107, 142, 118, 1)",
                      textDecoration: "none",
                    }}
                  >
                    support@insocialorbit.com
                  </Link>
                </li>
                <li>
                  <span className="contact-label">Phone : </span>
                  <Link
                    style={{
                      color: "rgba(107, 142, 118, 1)",
                      textDecoration: "none",
                    }}
                    to="tel:+919426026611"
                  >
                    +91 94260 26611
                  </Link>
                </li>
                <li>
                  <span className="contact-label">Address : </span> 606, Sixth
                  Floor, Rajpath Rangoli Rd, PRL Colony, Bodakdev, Ahmedabad,
                  Gujarat 380059
                </li>
                <li>
                  <span className="contact-label">Hours : </span> Open & Close
                  Time
                </li>
              </ul>
            </div>

            <div className="col-lg-6 col-md-6 col-xs-12 col-sm-7">
              <div className="map-container">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7343.33802801375!2d72.48093469357907!3d23.035922000000024!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9bfa4c41c8d3%3A0x8f07c10faafa4242!2sInSocial%20Orbit%20Pvt.Ltd!5e0!3m2!1sen!2sin!4v1736161027572!5m2!1sen!2sin"
                  width="100%"
                  height="300px"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map Location"
                ></iframe>
              </div>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="form-section p-5">
          <div className="container">
            <div className="form-title">
              <div className="title text-left mb-4">Connect With Us</div>
            </div>
            <ThemeProvider theme={theme}>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid size={6}>
                    <InputLabel
                      style={{ marginBottom: "4px !important" }}
                      label={"Name"}
                    />
                    <TextField
                      name="name"
                      placeholder="Enter Full Name"
                      sx={{ width: "100%" }}
                      onChange={handleChange}
                      value={values.name}
                      error={!!errors?.name}
                      helperText={errors.name}
                    />
                  </Grid>
                  <Grid size={6}>
                    <InputLabel
                      style={{ marginBottom: "4px !important" }}
                      label={"Email Address"}
                    />
                    <TextField
                      name="email"
                      placeholder="Enter Email Address"
                      sx={{ width: "100%" }}
                      onChange={handleChange}
                      value={values.email}
                      error={!!errors?.email}
                      helperText={errors.email}
                    />
                  </Grid>
                  <Grid size={6}>
                    <InputLabel
                      style={{ marginBottom: "4px !important" }}
                      label={"Phone Number"}
                    />
                    <NumberField
                      placeholder={"Enter Phone Number"}
                      error={errors?.mobile}
                      maxLength={10}
                      setError={setFieldError}
                      name={"mobile"}
                      handleChange={handleChange}
                      value={values.mobile}
                    />
                  </Grid>
                  <Grid size={12}>
                    <InputLabel
                      style={{ marginBottom: "4px !important" }}
                      label={"Subject"}
                    />
                    <TextField
                      placeholder="Enter Subject"
                      sx={{ width: "100%" }}
                      onChange={handleChange}
                      value={values.subject}
                      name="subject"
                      error={!!errors?.subject}
                      helperText={errors.subject}
                    />
                  </Grid>
                  <Grid size={6}>
                    <InputLabel
                      style={{ marginBottom: "4px !important" }}
                      label={"You are?"}
                    />
                    <RadioGroup
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      row
                      value={values.role}
                      onChange={(e, value) => setFieldValue("role", value)}
                    >
                      <FormControlLabel
                        value="brand"
                        control={<Radio />}
                        label="Brand"
                      />
                      <FormControlLabel
                        value="influencer"
                        control={<Radio />}
                        label="Influencer"
                      />
                    </RadioGroup>
                  </Grid>
                  {values.role === "brand" ? (
                    <Grid size={6}>
                      <InputLabel
                        style={{ marginBottom: "4px !important" }}
                        label={"You are?"}
                      />
                      <Slider
                        getAriaValueText={(value) =>
                          new Intl.NumberFormat("en-IN", {
                            style: "currency",
                            currency: "INR",
                          }).format(value)
                        }
                        valueLabelDisplay="auto"
                        onChange={(e, value) => setFieldValue("budget", value)}
                        step={1000}
                        value={values.budget}
                        marks={[
                          {
                            label: new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                            }).format(3000),
                            value: 3000,
                          },
                          {
                            label: new Intl.NumberFormat("en-IN", {
                              style: "currency",
                              currency: "INR",
                            }).format(5000000),
                            value: 5000000,
                          },
                        ]}
                        min={3000}
                        max={5000000}
                      />
                    </Grid>
                  ) : (
                    <></>
                  )}
                  <Grid size={12}>
                    <InputLabel
                      style={{ marginBottom: "4px !important" }}
                      label={"Your Message (Describe Your Query)"}
                    />
                    <TextField
                      multiline
                      minRows={6}
                      placeholder="Enter your message"
                      sx={{
                        width: "100%",
                      }}
                      onChange={handleChange}
                      value={values.message}
                      name="message"
                      error={!!errors?.message}
                      helperText={errors.message}
                    />
                  </Grid>
                  <Grid size={12} textAlign={"center"}>
                    <Button
                      variant="contained"
                      sx={{ minWidth: "200px" }}
                      type="submit"
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </ThemeProvider>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
